import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  FIRST_RUN_STEPS,
  FIRST_RUN_ALTERNATIVE_STEPS,
  deriveFirstRunStepCompletion,
} from '../utils/firstRunChecklist';

const FirstRunChecklist = ({
  tmsConfig,
  onCreateNew,
}) => {
  const navigate = useNavigate();
  const completion = deriveFirstRunStepCompletion({ tmsConfig });
  const connectDone = completion.connect_skyslope;
  const alternativesCurrent = connectDone;

  const handleStepAction = (step) => {
    if (step.action === 'create') {
      onCreateNew();
      return;
    }
    if (step.settingsTab) {
      navigate(`/settings?tab=${step.settingsTab}`);
    }
  };

  const renderStepButton = (step) => {
    if (step.mailto) {
      return (
        <a className="first-run-step-button" href={`mailto:${step.mailto}`}>
          Open email
        </a>
      );
    }
    if (step.action === 'create') {
      return (
        <button
          type="button"
          className="first-run-step-button"
          onClick={() => handleStepAction(step)}
        >
          + Create Form
        </button>
      );
    }
    return (
      <button
        type="button"
        className="first-run-step-button"
        onClick={() => handleStepAction(step)}
      >
        Open in Settings
      </button>
    );
  };

  return (
    <div className="first-run-checklist">
      <div className="first-run-checklist-header">
        <h3>Get Started with KeyFlo</h3>
        <p>
          Connect SkySlope first, then choose one way to add your first deal to KeyFlo.
        </p>
      </div>
      <ol className="first-run-steps">
        {FIRST_RUN_STEPS.map((step, index) => {
          const done = completion[step.id];
          const isCurrent = !done;
          return (
            <li
              key={step.id}
              className={`first-run-step ${done ? 'is-complete' : ''} ${isCurrent ? 'is-current' : ''}`}
            >
              <div className="first-run-step-marker" aria-hidden="true">
                {done ? '✓' : index + 1}
              </div>
              <div className="first-run-step-body">
                <div className="first-run-step-title">{step.title}</div>
                <div className="first-run-step-description">{step.description}</div>
                {!done && (
                  <div className="first-run-step-actions">
                    {renderStepButton(step)}
                  </div>
                )}
              </div>
            </li>
          );
        })}
        <li
          className={`first-run-step first-run-alternatives ${alternativesCurrent ? 'is-current' : ''}`}
        >
          <div className="first-run-step-marker" aria-hidden="true">2</div>
          <div className="first-run-step-body">
            <div className="first-run-step-title">Add your first deal</div>
            <div className="first-run-alternative-options">
              {FIRST_RUN_ALTERNATIVE_STEPS.map((step) => (
                <div key={step.id} className="first-run-alternative-option">
                  <div>
                    <div className="first-run-step-title">{step.title}</div>
                    <div className="first-run-step-description">{step.description}</div>
                    <div className="first-run-step-actions">
                      {renderStepButton(step)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </li>
      </ol>
    </div>
  );
};

export default FirstRunChecklist;
